import { HeatmapWSMessageType } from '../types/websocket';
import { useWSHeatmapBase } from './useWSHeatmapBase';

export const useWSHeatmapAnalytics = () => {
  return useWSHeatmapBase({
    dataType: 'analytics',
    wsMessageKey: HeatmapWSMessageType.ANALYTICS,
    cacheSelector: (state) => state.analyticsCache,
    upsertSelector: (state) => state.upsertAnalyticsCache,
    emptyData: undefined,
  });
};
